<div class="error-page">
    <h1>500</h1>
    <p>Something went wrong</p>
    <a routerLink="/admission/student-form">Go Home</a>
  </div>
